var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.meta.href ? 'a' : 'div',{tag:"component",staticClass:"image image-wrapper",class:{
		'image-wrapper--hoverable': Boolean(_vm.meta.href),
	},style:({
		paddingBottom: (((_vm.meta.ratioHeight/_vm.meta.ratioWidth)*100) + "%")
	}),attrs:{"href":_vm.meta.href,"target":_vm.meta.href ? '_blank' : null,"rel":_vm.meta.href ? 'noreferrer noopener' : null},on:{"click":_vm.onClick}},[_c('img',{staticClass:"image__image",attrs:{"alt":_vm.meta.altText,"src":_vm.meta.src}})])}
var staticRenderFns = []

export { render, staticRenderFns }